<template>
  <dashboard-widget title="SALES STATUS" :width="width" :enableDelete="enableDelete" no-zoom
                      @delete="$emit('delete','DashboardSalesStatus')">
    <v-container class="text-center text-caption">
      <v-row>
        <v-col cols="6">
          <v-card :to="{name:'SalesSalesOrders',query:{status:'topick'}}" hover :color="'white--text ' + (status.toPick?'error':'success')"
                  :disabled="!usePicking">
            <div>TO PICK</div>
            <div class="text-h5">{{status.toPick}}</div>
            <div>Sales Order{{status.toPick === 1 ? '' : 's'}}</div>
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card :to="{name:'SalesSalesOrders',query:{status:'toship'}}" :color="'white--text ' + (status.toShip?'error':'success')">
            <div>TO SHIP</div>
            <div class="text-h5">{{status.toShip}}</div>
            <div>Sales Order{{status.toShip === 1 ? '' : 's'}}</div>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <v-card :to="{name:'SalesShipments',query:{draft:'1'}}" :color="'white--text ' + (status.draftShipments?'error':'success')">
            <div>DRAFTS</div>
            <div class="text-h5">{{status.draftShipments}}</div>
            <div>Shipment{{status.draftShipments === 1 ? '' : 's'}}</div>
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card :to="{name:'SalesShipments',query:{delivered:'0'}}" :color="'white--text ' + (status.toDeliver?'error':'success')">
            <div>TO DELIVER</div>
            <div class="text-h5">{{status.toDeliver}}</div>
            <div>Shipment{{status.toDeliver === 1 ? '' : 's'}}</div>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <v-card :to="{name:'SalesSalesOrders',query:{status:'toinvoice'}}" :color="'white--text ' + (status.toInvoice?'error':'success')">
            <div>TO INVOICE</div>
            <div class="text-h5">{{status.toInvoice}}</div>
            <div>Sales Order{{status.toInvoice === 1 ? '' : 's'}}</div>
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card :to="{name:'SalesInvoices',query:{draft:'1'}}" :color="'white--text ' + (status.draftInvoices?'error':'success')">
            <div>DRAFTS</div>
            <div class="text-h5">{{status.draftInvoices}}</div>
            <div>Invoice{{status.draftInvoices === 1 ? '' : 's'}}</div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </dashboard-widget>
</template>

<script>

export default {
  name: 'DashboardSalesStatus',
  props: {
    width: {type:Number, required:false, default:290},
    enableDelete: {type: Boolean, required:false, default:false},
    disableTo: {type: Boolean, required:false, default:false}
  },
  data() {
    return {
      usePicking: true,
      status : {}
    }
  },
  async created() {
    const results = await this.$apiCall(`query DashboardSalesStatus {
                                            salesPreferences {
                                              usePicking
                                            }
                                            salesStatus {
                                              toPick,toShip,toInvoice,draftShipments,draftInvoices,toDeliver
                                            }
                                        }`);
    if (!results.error) {
      this.usePicking = results.data.salesPreferences.usePicking;
      if (!this.usePicking)
        results.data.salesStatus.toPick = 0;
      this.status = results.data.salesStatus;
    }
  }
}
</script>